module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('accordion', _vm._l((_vm.services), function(service, index) {
    return _c('div', {
      staticClass: "dependant"
    }, [_c('accordion-item', [_c('h2', {
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_vm._v("\n                    Dependency on service " + _vm._s(index + 1) + "\n                    " + _vm._s(service.descriptionOfService ? ' - ' + service.descriptionOfService : '') + "\n                ")]), _vm._v(" "), _c('service', {
      attrs: {
        "index": index
      },
      on: {
        "check": _vm.updateValid
      }
    })], 1)], 1)
  }), 0), _vm._v(" "), _c('step-button', {
    attrs: {
      "next-valid": _vm.stepValid
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2cf4cfa2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/fatal-accident-claims/dependency/steps/DependencyOnServices.vue
// module id = 1621
// module chunks = 0